import './PhoneMockup.css';

const PhoneMockup = ({src, alt, className = '', loading = 'lazy'}) => (
    <figure className={`phone-mockup ${className}`}>
        <img src={src} alt={alt} loading={loading}/>
    </figure>
);

export default PhoneMockup;
